import React from 'react';
import { useLocalStorage } from 'react-use';
import {
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';

function Formula ({answer}) {

  const [auth] = useLocalStorage('authenticated');

  return (
    <Row>
      <Col md="12">
        <Card>
          <Card.Header>
            <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap',marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="10">
                <Form.Group>
                  <Row>
                    <Col md="2">
                      <Form.Label>Auditee's Answer</Form.Label>
                      <p>
                        {answer.ANSWER_DESC ?? <span class="text-danger">Not answered yet.</span>}
                      </p>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group>
                  {answer.answerAttachments.length
                    ? answer.answerAttachments.map(attachment => (
                      <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`}>
                        {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                      </a>
                    ))
                    : (<p>No attachment uploaded.</p>)}
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Formula;